import { useState } from "react";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import IDUploadForm from "../IDVerification/IDUploadForm";
import GuestSearchStep from "./GuestSearchStep";

const STEPS = ["Capture & review ID", "Guest search"];

/**
 * GuestCheckinFlow — top-level orchestrator
 *
 * Mount inside a Dialog, page, or drawer.
 *
 * Props:
 *   onComplete({ action: "created" | "linked", guest: object })
 *   onCancel()  — optional, wire to Dialog onClose
 *
 * File layout:
 *   IDUploadForm.jsx    — Steps 1+2: scan/manual + review (existing file, rewritten)
 *   GuestSearchStep.jsx — Step 3:   auto-search table, select or create
 *   GuestCheckinFlow.jsx — this file, new
 */
export default function GuestCheckinFlow({ onComplete, onCancel }) {
  const [step, setStep] = useState(0); // 0 = capture+review, 1 = guest search

  // Carried between steps
  const [formData, setFormData]       = useState(null);
  const [scanURL, setScanURL]         = useState(null);
  const [editedFields, setEditedFields] = useState(new Set());
  const [entryMode, setEntryMode] = useState(null);

  // IDUploadForm calls this when the manager finishes capture OR review
  const handleIDComplete = ({ form, scanURL: url, editedFields: edited, mode  }) => {
    setFormData(form);
    setScanURL(url);
    setEditedFields(edited);
    setEntryMode(mode);
    setStep(1);
  };

  const handleBackToID = () => setStep(0);

  return (
    <Box sx={{ px: { xs: 2, sm: 2 }, py:2, maxWidth: 860, mx: "auto" }}>
      <Stepper activeStep={step} sx={{ mb: 1 }}>
        {STEPS.map((label) => (
          <Step key={label}>
            <StepLabel sx={{ "& .MuiStepLabel-label": { fontSize: 13 } }}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
      <IDUploadForm
        onComplete={handleIDComplete}
        onCancel={onCancel}
        initialView={scanURL ? "review" : "capture"}
        initialTab={entryMode === "manual" ? 1 : 0}
        initialForm={formData}
        initialScanURL={scanURL}
      />
    )}

      {step === 1 && formData && (
        <GuestSearchStep
          form={formData}
          onBack={handleBackToID}
          onComplete={onComplete}
        />
      )}
    </Box>
  );
}